import Promores from "./promo-residential.webp";
import Promoruko from "./promoruko.webp";

const promohs = { Promores, Promoruko };

export default promohs;
